<script>
import { mapGetters, mapActions } from "vuex";
import config from "../../../config/config";
import { debounce } from "../../../state/helpers";
import { formatIST } from "../../../config/moment";
// import { param } from "express/lib/request";
/**
 * Add-product component
 */
export default {
  data() {
    return {
      config: config,
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 10,
      search: "",
      formatIST,
      id: "",
      booking: {
        is_cancel: [],
      },
      searchData: debounce(() => {
        this.getBusyChargers();
        this.init = false;
      }, 500),
      fields: [
        {
          key: "id",
          sortable: true,
          label: "#",
        },
        {
          key: "name",
          sortable: true,
          label: "Charging Stations",
        },
        {
          key: "city",
          sortable: true,
          label: "City",
        },
        {
          key: "start_time",
          sortable: true,
          label: "Start Time",
        },
        {
          key: "end_time",
          sortable: true,
          label: "End Time",
        },
        {
          key: "users",
          sortable: true,
          label: "User",
        },
        {
          key: "is_private",
          sortable: true,
          label: "Type",
        },
      ],
    };
  },
  props: ["userId"],
  components: {},
  validations: {},
  computed: {
    ...mapGetters("chargerStatus", [
      "getAllBusyCharger",
      "loading",
      "busyChargerCount",
      "pagination",
    ]),
  },
  mounted() {
    this.getBusyChargers();
  },
  methods: {
    ...mapActions("chargerStatus", ["getBusyCharger"]),
    getBusyChargers(page = 1) {
      var filters = {
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
      };
      this.getBusyCharger(filters);
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getBusyChargers();
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <!-- profile Info Start -->
        <div class="card details-profile-main date-picker-space">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-5">
                <div
                  class="pb-0 page-title-box d-flex align-items-center justify-content-between icon-main-page"
                >
                  <h4 class="card-title page-title-left">
                    Busy Chargers ({{ busyChargerCount }})
                  </h4>
                </div>
              </div>
              <div class="col-md-5">
                <div class="row justify-content-end">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <div class="date-range-list">
                        <label>Per Page :</label>
                        <select
                          class="custom-select"
                          v-model="perPages"
                          @change="searchData()"
                        >
                          <option value="5" selected>5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="date-range-list">
                      <label>Search :</label>
                      <div class="text-sm-right">
                        <div class="search-box mr-2 d-inline-block">
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control"
                              id="search"
                              @input="searchData()"
                              v-model="search"
                              :placeholder="$t('navbar.search.text')"
                            />
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <a
                    :href="config.appurl + 'download-busy-charger-data'"
                    class="btn btn-primary btn-md btn-rounded ml-1"
                  >
                    Download All Data
                  </a>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :items="getAllBusyCharger"
                  :fields="fields"
                  :busy="loading"
                  class="busy-table-class"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(station)="items">
                    {{ items.item ? items.item.name : "" }}
                  </template>
                  <template v-slot:cell(city)="items">
                    {{ items.item ? items.item.city : "" }}
                  </template>
                  <template v-slot:cell(users)="items">
                    {{ items.item.users ? items.item.users : "" }}
                  </template>
                  <template v-slot:cell(start_time)="items">
                    {{ formatIST(items.item.start_time) }}
                  </template>
                  <template v-slot:cell(end_time)="items">
                    {{ formatIST(items.item.end_time) }}
                  </template>
                  <template v-slot:cell(is_private)="items">
                    {{ items.item.is_private == 1 ? "Private" : "Public" }}
                  </template>
                </b-table>
                <tr v-if="loading == false && getAllBusyCharger.length === 0">
                  <td colspan="100%">
                    <h6 align="center">No Busy Charger Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getBusyChargers"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- profile Info End -->
      </form>
    </div>
  </div>
</template>
<style>
.card.date-picker-space {
  margin-bottom: 100px;
}
.busy-table-class {
  table-layout: fixed;
}
.busy-table-class th:first-child {
  width: 50px;
}
.busy-table-class th:nth-child(2n) {
  width: 350px;
}
.busy-table-class th:nth-child(3n) {
  width: 150px;
}
.busy-table-class th:nth-child(5n) {
  width: 100px;
}
.busy-table-class th:nth-child(6n) {
  width: 200px;
}
.busy-table-class th:nth-child(4n) {
  width: 120px;
}
</style>
